//IE11 swiper js 'startsWith' Polyfill
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0
    return this.substr(position, searchString.length) === searchString
  }
}
const focusableEl = ['a', 'button']
function doAllSlidesNotReadable() {
  this.slides.forEach((slide) => {
    slide.ariaHidden = true
    focusableEl.forEach((selector) => {
      slide
        .querySelectorAll(`${selector}:not(.not-focusable)`)
        .forEach((el) => {
          el.tabIndex = -1
          el.ariaHidden = true
        })
    })
  })
}

function doActiveSlideReadable() {
  let activeIndex = this.activeIndex
  this.slides.forEach((slide, index) => {
    if (index === activeIndex) {
      slide.ariaHidden = false
      focusableEl.forEach((selector) => {
        slide
          .querySelectorAll(`${selector}:not(.not-focusable)`)
          .forEach((el) => {
            el.tabIndex = 0
            el.ariaHidden = false
          })
      })
    }
  })
}

var bathSwiper = new Swiper('#bath-slider .swiper-container', {
  preventClicks: true,
  preventClicksPropagation: true,
  slidesPerView: 1,
  spaceBetween: 0,
  parallax: true,
  speed: 1000,
  centeredSlides: false,
  allowTouchMove: true,
  loop: true,
  a11y: {
    enabled: true,
    slideLabelMessage: '',
    slideRole: ''
  },
  pagination: {
	el: "#bath-slider .swiper-pagination",
	type: "fraction",
  },
  navigation: {
    prevEl: `#bath-slider .swiper-button-prev`,
    nextEl: `#bath-slider .swiper-button-next`
  },
  breakpoints: {
    769: {
      slidesPerView: 1
    }
  },
  on: {
    init: function () {
      doAllSlidesNotReadable.call(this)
      doActiveSlideReadable.call(this)
    },
    slideChangeTransitionStart: function () {
      doAllSlidesNotReadable.call(this)
    },
    slideChangeTransitionEnd: function () {
      doActiveSlideReadable.call(this)
    }
  }
})
var fragranceSwiper = new Swiper('#fragrance-slider .swiper-container', {
	preventClicks: true,
	preventClicksPropagation: true,
	slidesPerView: 3,
	spaceBetween: 32,
	parallax: true,
	speed: 1000,
	centeredSlides: false,
	allowTouchMove: false,
	loop: false,
	slidesPerGroup: 3,
	a11y: {
	  enabled: true,
	  slideLabelMessage: '',
	  slideRole: ''
	},
	pagination: {
	  el: "#fragrance-slider .swiper-pagination",
	  type: "fraction",
	},
	navigation: {
	  prevEl: `#fragrance-slider .swiper-button-prev, #fragrance-slider .hp-hotel-collection`,
	  nextEl: `#fragrance-slider .swiper-button-next, #fragrance-slider .hp-spa-collection`
	},
	breakpoints: {
	  769: {
		slidesPerView: 3
	  }
	},
	on: {
	  init: function () {
		doAllSlidesNotReadable.call(this)
		doActiveSlideReadable.call(this)
	  },
	  slideChangeTransitionStart: function () {
		doAllSlidesNotReadable.call(this)
	  },
	  slideChangeTransitionEnd: function () {
		doActiveSlideReadable.call(this)
	  }
	}
  })

// Image
var swiper = new Swiper('.item-image .swiper-container', {
  slidesPerView: 1,
  spaceBetween: 0,
  watchOverflow: true,
  zoom: {
	enabled: true
  },
  a11y: {
    enabled: true,
    slideRole: '',
    slideLabelMessage: ''
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
})
